// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"input_inputBox__2uurb","error":"input_error__3NkaX"};